module.exports = __webpack_public_path__ + "components/star-rating/static/white/6-f577054166b58675492d4df51fc2c67e.svg";